import {
  favoriteOrgListResponseSchema,
  favoriteOrgRequestSchema,
  saveJobRequestSchema,
  savedJobListResponseSchema,
  type FavoriteOrgRequest,
  type SaveJobRequest,
} from "@chotca/config";
import { z } from "zod";
import type { RequestContext } from "./http";
import { requestJson } from "./http";

export function createSavedResource(ctx: RequestContext) {
  return {
    listSavedJobs(cursor?: string, limit?: number) {
      const qs = new URLSearchParams();
      if (cursor) qs.set("cursor", cursor);
      if (limit) qs.set("limit", String(limit));
      const q = qs.toString();
      return requestJson(ctx, {
        method: "GET",
        path: `/me/saved-jobs${q ? `?${q}` : ""}`,
        dataSchema: savedJobListResponseSchema,
        auth: true,
      });
    },
    saveJob(body: SaveJobRequest) {
      const payload = saveJobRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "POST",
        path: `/me/saved-jobs`,
        body: payload,
        dataSchema: z.object({ ok: z.literal(true) }),
        auth: true,
      });
    },
    unsaveJob(postingId: string) {
      return requestJson(ctx, {
        method: "DELETE",
        path: `/me/saved-jobs/${postingId}`,
        dataSchema: z.object({ ok: z.literal(true) }),
        auth: true,
      });
    },
    listFavoriteOrgs(cursor?: string, limit?: number) {
      const qs = new URLSearchParams();
      if (cursor) qs.set("cursor", cursor);
      if (limit) qs.set("limit", String(limit));
      const q = qs.toString();
      return requestJson(ctx, {
        method: "GET",
        path: `/me/favorite-orgs${q ? `?${q}` : ""}`,
        dataSchema: favoriteOrgListResponseSchema,
        auth: true,
      });
    },
    favoriteOrg(body: FavoriteOrgRequest) {
      const payload = favoriteOrgRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "POST",
        path: `/me/favorite-orgs`,
        body: payload,
        dataSchema: z.object({ ok: z.literal(true) }),
        auth: true,
      });
    },
    unfavoriteOrg(orgId: string) {
      return requestJson(ctx, {
        method: "DELETE",
        path: `/me/favorite-orgs/${orgId}`,
        dataSchema: z.object({ ok: z.literal(true) }),
        auth: true,
      });
    },
  };
}
